import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-69070706")

_pushScopeId("data-v-69070706")
const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#example" }),
  /*#__PURE__*/_createTextVNode(" Example ")
], -1)
const _hoisted_3 = { class: "rounded border p-10" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "el-icon-message" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Navigator One")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Group 1")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Option 1")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Option 2")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Option 3")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Option4")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Option 4-1")
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "el-icon-menu" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Navigator Two")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Group 1")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Option 1")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Option 2")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Option 3")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Option 4")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Option 4-1")
const _hoisted_20 = /*#__PURE__*/_createVNode("i", { class: "el-icon-setting" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Navigator Three")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Group 1")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Option 1")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Option 2")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Option 3")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Option 4")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Option 4-1")
const _hoisted_28 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-setting",
  style: {"margin-right":"15px"}
}, null, -1)
const _hoisted_29 = /*#__PURE__*/_createTextVNode("View")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Add")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Delete")
const _hoisted_32 = /*#__PURE__*/_createVNode("span", null, "Tom", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")
  const _component_el_menu_item_group = _resolveComponent("el-menu-item-group")
  const _component_el_submenu = _resolveComponent("el-submenu")
  const _component_el_menu = _resolveComponent("el-menu")
  const _component_el_aside = _resolveComponent("el-aside")
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")
  const _component_el_header = _resolveComponent("el-header")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_el_container, { style: {"height":"500px","border":"1px solid #eee"} }, {
        default: _withId(() => [
          _createVNode(_component_el_aside, {
            width: "200px",
            style: {"background-color":"rgb(238, 241, 246)"}
          }, {
            default: _withId(() => [
              _createVNode(_component_el_menu, { "default-openeds": ['1', '3'] }, {
                default: _withId(() => [
                  _createVNode(_component_el_submenu, { index: "1" }, {
                    title: _withId(() => [
                      _hoisted_4,
                      _hoisted_5
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_el_menu_item_group, null, {
                        title: _withId(() => [
                          _hoisted_6
                        ]),
                        default: _withId(() => [
                          _createVNode(_component_el_menu_item, { index: "1-1" }, {
                            default: _withId(() => [
                              _hoisted_7
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_menu_item, { index: "1-2" }, {
                            default: _withId(() => [
                              _hoisted_8
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item_group, { title: "Group 2" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_menu_item, { index: "1-3" }, {
                            default: _withId(() => [
                              _hoisted_9
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_submenu, { index: "1-4" }, {
                        title: _withId(() => [
                          _hoisted_10
                        ]),
                        default: _withId(() => [
                          _createVNode(_component_el_menu_item, { index: "1-4-1" }, {
                            default: _withId(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_submenu, { index: "2" }, {
                    title: _withId(() => [
                      _hoisted_12,
                      _hoisted_13
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_el_menu_item_group, null, {
                        title: _withId(() => [
                          _hoisted_14
                        ]),
                        default: _withId(() => [
                          _createVNode(_component_el_menu_item, { index: "2-1" }, {
                            default: _withId(() => [
                              _hoisted_15
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_menu_item, { index: "2-2" }, {
                            default: _withId(() => [
                              _hoisted_16
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item_group, { title: "Group 2" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_menu_item, { index: "2-3" }, {
                            default: _withId(() => [
                              _hoisted_17
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_submenu, { index: "2-4" }, {
                        title: _withId(() => [
                          _hoisted_18
                        ]),
                        default: _withId(() => [
                          _createVNode(_component_el_menu_item, { index: "2-4-1" }, {
                            default: _withId(() => [
                              _hoisted_19
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_submenu, { index: "3" }, {
                    title: _withId(() => [
                      _hoisted_20,
                      _hoisted_21
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_el_menu_item_group, null, {
                        title: _withId(() => [
                          _hoisted_22
                        ]),
                        default: _withId(() => [
                          _createVNode(_component_el_menu_item, { index: "3-1" }, {
                            default: _withId(() => [
                              _hoisted_23
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_menu_item, { index: "3-2" }, {
                            default: _withId(() => [
                              _hoisted_24
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item_group, { title: "Group 2" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_menu_item, { index: "3-3" }, {
                            default: _withId(() => [
                              _hoisted_25
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_submenu, { index: "3-4" }, {
                        title: _withId(() => [
                          _hoisted_26
                        ]),
                        default: _withId(() => [
                          _createVNode(_component_el_menu_item, { index: "3-4-1" }, {
                            default: _withId(() => [
                              _hoisted_27
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_container, null, {
            default: _withId(() => [
              _createVNode(_component_el_header, { style: {"text-align":"right","font-size":"12px"} }, {
                default: _withId(() => [
                  _createVNode(_component_el_dropdown, null, {
                    dropdown: _withId(() => [
                      _createVNode(_component_el_dropdown_menu, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_dropdown_item, null, {
                            default: _withId(() => [
                              _hoisted_29
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_dropdown_item, null, {
                            default: _withId(() => [
                              _hoisted_30
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_dropdown_item, null, {
                            default: _withId(() => [
                              _hoisted_31
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withId(() => [
                      _hoisted_28
                    ]),
                    _: 1
                  }),
                  _hoisted_32
                ]),
                _: 1
              }),
              _createVNode(_component_el_main, null, {
                default: _withId(() => [
                  _createVNode(_component_el_table, { data: _ctx.tableData }, {
                    default: _withId(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "date",
                        label: "Date",
                        width: "140"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "name",
                        label: "Name",
                        width: "120"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "address",
                        label: "Address"
                      })
                    ]),
                    _: 1
                  }, 8, ["data"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.code2), 1)
        ]),
        _: 1
      })
    ])
  ]))
})